import styled, { css } from 'styled-components'
import {
  txt14OpenSans,
  txt16OpenSans,
  title32GalanoBold,
  title16Galano
} from 'styles/settings/types'
import { linkNavyBlue, posGreyInfo, darkSlateBlue, white } from 'styles/settings/colors'
import rem from 'styles/tools/rem'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 380px;
`

export const WrapperContentModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem('48px')};
  width: 100%;
  overflow: hidden;
`

export const Header = styled.div`
  ${title32GalanoBold};
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: ${linkNavyBlue};
  margin-bottom: 20px;
`

export const Back = styled.a`
  ${txt14OpenSans};
  font-weight: bold;
  line-height: 1;
  color: ${linkNavyBlue};
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: ${rem('16px')};
  cursor: pointer;

  svg {
    fill: ${posGreyInfo};
  }
`

export const Content = styled.div`
  padding: ${rem('24px')};
`

export const WrapperButton = styled.div`
  display: flex;
  justify-content: ${props => props.justify};

  margin-top: 40px;

  button:first-child {
    margin-right: 16px;
  }
`
WrapperButton.defaultProps = {
  justify: 'flex-end'
}

export const Input = styled.input`
  ${txt16OpenSans};
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};

  background-color: rgba(226, 225, 235, 0.16);
  color: ${darkSlateBlue};

  padding: ${rem('16px')} ${rem('16px')} ${rem('16px')} ${rem('16px')};
  line-height: ${rem('24px')};

  width: 100%;
`

export const Button = styled.button`
  ${title16Galano};
  line-height: 20.8px;
  color: ${({ secondary }) => (secondary ? darkSlateBlue : white)};

  background-color: ${({ secondary }) => (secondary ? white : darkSlateBlue)};
  padding: 16px 32px;
  min-width: 116px;
  height: 52px;

  border: none;
  border-radius: 28px;
  ${({ secondary }) =>
    secondary &&
    css`
      border: 2px solid ${darkSlateBlue};
    `};
  cursor: pointer;
`

export const Paragraph = styled.p`
  ${txt14OpenSans};
  color: ${darkSlateBlue};
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/CreateEditFilterSelectionModal/styles.js